

export const SET_QUESTION_EXPLAIN_CURRENT = "set question explain current";





// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_explain/actionType.js